var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupEnableLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.81868C6.76042 8.97328 6.87248 9.11962 7.00215 9.25455C7.80715 10.0923 9.03415 10.2234 9.97108 9.64748C10.1447 9.54075 10.3083 9.40982 10.4575 9.25455L12.6171 7.00695C13.5712 6.01391 13.5712 4.40386 12.6171 3.4108C11.6629 2.41775 10.1159 2.41776 9.16168 3.4108L8.68602 3.90587",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31288 12.0933L6.83702 12.5885C5.88286 13.5816 4.33582 13.5816 3.38165 12.5885C2.42747 11.5955 2.42747 9.98546 3.38165 8.9924L5.54126 6.7448C6.49544 5.75174 8.04248 5.75173 8.99662 6.7448C9.12628 6.87966 9.23828 7.026 9.33268 7.18053",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupEnableLink);
export default __webpack_public_path__ + "static/media/group_enable_link.032a7ee88f2c89d7819afbea6b61351a.svg";
export { ForwardRef as ReactComponent };